exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Hind+Madurai:400,700);", ""]);
var urlEscape = require("../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("assets/fonts/HindMysuru-Bold.otf"));

// Module
exports.push([module.id, "@font-face{font-family:\"HindMysuru-Bold\";src:url(" + ___CSS_LOADER_URL___0___ + ") format(\"opentype\")}.button[data-v-7e803892]{display:flex;flex-direction:row;align-items:center;justify-content:center}.icon[data-v-7e803892],.small-icon[data-v-7e803892]{align-self:flex-start;width:26px;height:26px;display:block;margin-left:auto;margin-right:10px;margin-bottom:3%}.small-icon[data-v-7e803892]{width:16px;height:16px;margin-right:5px}\n", ""]);

